/*
 * Upsell panier — cases à cocher, total projeté, ajout en un appel.
 *
 * ⚠️ LE TIROIR SE RECONSTRUIT, LE SCRIPT DOIT SURVIVRE. Le thème est en
 * `cart_type: drawer` : à chaque ajout, Shopify re-rend le tiroir par la Section
 * Rendering API et remplace le DOM. Un script qui s'initialise une seule fois au
 * chargement serait mort dès le premier ajout. D'où l'observateur de mutations,
 * qui réarme tout bloc fraîchement inséré.
 *
 * ⚠️ ET LE BLOC PEUT ÊTRE RENDU DEUX FOIS sur la même page — costume ET décor.
 * On initialise donc par bloc, jamais globalement, avec une marque sur chacun.
 */
(function () {
  if (window.__upsellPanierArme) return;
  window.__upsellPanierArme = true;

  function armer(bloc) {
    if (bloc.dataset.pret) return;
    bloc.dataset.pret = '1';

    var bouton = bloc.querySelector('[data-upsell-ajouter]');
    var erreur = bloc.querySelector('[data-upsell-erreur]');
    var projete = bloc.querySelector('[data-upsell-projete]');
    var futur = bloc.querySelector('[data-upsell-futur]');
    if (!bouton) return;

    var actuel = Number(bloc.dataset.totalPanier || 0);
    /* ⚠️ NE PAS INVENTER DE DEVISE EN REPLI. Cette boutique vend en USD ;
       un repli codé « EUR » aurait affiché « 124,80 € » sur un panier en
       dollars — un montant faux, et crédible. Sans devise connue, on affiche
       le nombre seul plutôt qu'un symbole inventé. */
    var devise = bloc.dataset.devise || '';

    function coches() {
      return Array.prototype.slice.call(
        bloc.querySelectorAll('[data-upsell-ligne] input[type="checkbox"]')
      ).filter(function (c) { return c.checked; });
    }

    /* Le prix suit la variante choisie : changer de teinte doit changer le
       total quand les teintes ne valent pas le même prix. */
    function prixLigne(ligne) {
      var choix = ligne.querySelector('.upsell-panier__variante');
      if (choix) {
        var opt = choix.options[choix.selectedIndex];
        if (opt && opt.dataset.prix) return Number(opt.dataset.prix);
      }
      return Number(ligne.dataset.prix || 0);
    }

    function argent(centimes) {
      var langue = document.documentElement.lang || undefined;
      if (devise) {
        try {
          return new Intl.NumberFormat(langue, {
            style: 'currency', currency: devise
          }).format(centimes / 100);
        } catch (e) { /* devise inconnue d'Intl : on retombe plus bas */ }
      }
      try {
        return new Intl.NumberFormat(langue, {
          minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(centimes / 100) + (devise ? ' ' + devise : '');
      } catch (e) {
        return (centimes / 100).toFixed(2) + (devise ? ' ' + devise : '');
      }
    }

    function majTotal() {
      if (!projete || !futur) return;
      var ajout = coches().reduce(function (somme, c) {
        return somme + prixLigne(c.closest('[data-upsell-ligne]'));
      }, 0);
      if (ajout === 0) { projete.hidden = true; return; }
      futur.textContent = argent(actuel + ajout);
      projete.hidden = false;
    }

    function majBouton() {
      var n = coches().length;
      bouton.disabled = n === 0;
      if (n === 0) bouton.textContent = bloc.dataset.libelleVide;
      else if (n === 1) bouton.textContent = bloc.dataset.libelleUn;
      else bouton.textContent = bloc.dataset.libelleN.replace('{n}', n);
    }

    bloc.addEventListener('change', function () { majBouton(); majTotal(); });
    majBouton();
    majTotal();

    bouton.addEventListener('click', function () {
      var items = coches().map(function (c) {
        var ligne = c.closest('[data-upsell-ligne]');
        var choix = ligne.querySelector('.upsell-panier__variante');
        return { id: Number(choix ? choix.value : ligne.dataset.variant), quantity: 1 };
      });
      if (!items.length) return;

      bouton.disabled = true;
      if (erreur) erreur.hidden = true;

      /* Un seul appel pour tout ce qui est coché : deux articles ne doivent pas
         produire deux allers-retours, ni un panier à moitié rempli si le second
         échoue. */
      var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root : '/';

      fetch(racine + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
          return r.json();
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          if (erreur) {
            erreur.textContent = bloc.dataset.libelleErreur;
            erreur.hidden = false;
          }
          bouton.disabled = false;
          majBouton();
        });
    });
  }

  function balayer() {
    document.querySelectorAll('[data-upsell-panier]').forEach(armer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', balayer);
  } else {
    balayer();
  }

  document.addEventListener('shopify:section:load', balayer);

  var enAttente = false;
  new MutationObserver(function () {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () { enAttente = false; balayer(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
